export function convertSendTime(time: string): string {
  const defaultValue = 'PT0S';

  if (!time || !time.includes(':')) return defaultValue;

  const [hoursStr, minutesStr] = time.split(':');
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  if ((hours || 0) === 0 && (minutes || 0) === 0) return defaultValue;

  let result = 'PT';

  if (hours > 0) result += `${hours}H`;
  if (minutes > 0) result += `${minutes}M`;

  return result;
}
